import * as React from "react";
import Slider from "../Common/Slider";
import SliderNavigation from "../Common/Slider/Navigation";
import SliderPagination from "../Common/Slider/Pagination";
import TemplateString from "../Common/TemplateString";
import Section from "../Layout/Section";
import ArticleCard from "../Article/Card";
import * as styles from "./articles.module.css";

const SolutionArticles = ({articles}) => {
    if (!articles) {
        return null;
    }

    const items = articles.articles;

    return (
        <Section>
            <Slider
                title={<TemplateString template={articles.title} />}
                alignLeft
                navigation={<SliderNavigation />}
                pagination={<SliderPagination />}
                sliderClassName={`${styles.articles} ${
                    styles[`articles_count_${items.length > 4 ? 4 : items.length}`]
                }`}
                containerClassName={styles.articles__container}
                titleClassName={styles.articles__title}
            >
                {items.map((article) => {
                    const articleData = {
                        title: article.title,
                        description: article.description,
                        date: new Date(article.published_at),
                        readingTime: article.readingTime,
                        url: `/blog/${article.slug}`,
                        featuredImage: article.featuredImage,
                    };

                    return <ArticleCard {...articleData} key={article.id} />;
                })}
            </Slider>
        </Section>
    );
};

export default SolutionArticles;
